<template>
  <SliceZone
    wrapper="main"
    :slices="page?.data.slices ?? []"
    :components="components"
    class="current-page"
  />
</template>

<script setup lang="ts">
import { components } from "~/slices";

const router = useRouter();

const prismic = usePrismic();
const route = useRoute();
const { data: page } = await useAsyncData(
  `[product_category-uid-${route.params.uid}]`,
  () => prismic.client.getByUID("product_category", route.params.uid as string)
);

// useHead({
//   title: page.value?.data.meta_title,
//   meta: [
//     {
//       name: "description",
//       content: page.value?.data.meta_description,
//     },
//   ],
// });
</script>
